// Mock equipment models data
export const mockEquipmentModels = {
  ct: [
    {
      id: 'ct-1',
      name: 'Siemens SOMATOM Emotion',
      manufacturer: 'Siemens Healthineers',
      category: 'CT Scanner',
      specifications: {
        slices: '16 Slice',
        rotationTime: '0.6s',
        detectorRows: '16'
      },
      year: '2017',
      condition: 'Very Good - Certified',
      availability: 'Available',
      image: 'https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800&h=600&fit=crop'
    },
    {
      id: 'ct-2',
      name: 'Siemens SOMATOM Scope',
      manufacturer: 'Siemens Healthineers',
      category: 'CT Scanner',
      specifications: {
        slices: '16/32 Slice',
        rotationTime: '0.5s',
        detectorRows: '16-32'
      },
      year: '2018',
      condition: 'Excellent - Fully Refurbished',
      availability: 'Available',
      image: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=800&h=600&fit=crop'
    },
    {
      id: 'ct-3',
      name: 'Siemens SOMATOM Definition AS',
      manufacturer: 'Siemens Healthineers',
      category: 'CT Scanner',
      specifications: {
        slices: '64-slice',
        rotationTime: '0.33s',
        detectorRows: '64'
      },
      year: '2019',
      condition: 'Excellent - Tested & Certified',
      availability: 'Available',
      image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&h=600&fit=crop'
    },
    {
      id: 'ct-4',
      name: 'Siemens SOMATOM Emotion 128',
      manufacturer: 'Siemens Healthineers',
      category: 'CT Scanner',
      specifications: {
        slices: '128-slice',
        rotationTime: '0.4s',
        detectorRows: '128'
      },
      year: '2020',
      condition: 'Excellent - Premium Grade',
      availability: 'In Stock',
      image: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&h=600&fit=crop'
    }
  ],
  mri: [
    {
      id: 'mri-1',
      name: 'Siemens Magnetom Essenza 1.5T',
      manufacturer: 'Siemens Healthineers',
      category: 'MRI System',
      specifications: {
        fieldStrength: '1.5 Tesla',
        magnetType: 'Superconducting',
        gradientStrength: '33 mT/m'
      },
      year: '2018',
      condition: 'Excellent - Complete Refurbishment',
      availability: 'Available',
      image: 'https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=800&h=600&fit=crop'
    },
    {
      id: 'mri-2',
      name: 'Siemens Magnetom Verio 3.0T',
      manufacturer: 'Siemens Healthineers',
      category: 'MRI System',
      specifications: {
        fieldStrength: '3.0 Tesla',
        magnetType: 'Superconducting',
        gradientStrength: '45 mT/m'
      },
      year: '2020',
      condition: 'Excellent - Premium Grade',
      availability: 'In Stock',
      image: 'https://images.unsplash.com/photo-1512678080530-7760d81faba6?w=800&h=600&fit=crop'
    }
  ],
  cathlab: [
    {
      id: 'cath-1',
      name: 'Philips Allura Xper FD20',
      manufacturer: 'Philips Healthcare',
      category: 'Cath Lab',
      specifications: {
        imageQuality: 'Premium Digital',
        detectorSize: '20x20 cm',
        rotation: 'Full rotation capability'
      },
      year: '2019',
      condition: 'Excellent - Certified',
      availability: 'Available',
      image: 'https://images.unsplash.com/photo-1581093458791-9d42e45e0c48?w=800&h=600&fit=crop'
    },
    {
      id: 'cath-2',
      name: 'Philips Allura Xper FD10',
      manufacturer: 'Philips Healthcare',
      category: 'Cath Lab',
      specifications: {
        imageQuality: 'High Resolution',
        detectorSize: '30x30 cm',
        rotation: '120° orbital rotation'
      },
      year: '2018',
      condition: 'Very Good - Fully Serviced',
      availability: 'Available',
      image: 'https://images.unsplash.com/photo-1579154204601-01588f351e67?w=800&h=600&fit=crop'
    },
    {
      id: 'cath-3',
      name: 'Philips Alura Xper FD 20/20 Biplane',
      manufacturer: 'Philips Healthcare',
      category: 'Cath Lab',
      specifications: {
        imageQuality: 'Dual Plane Imaging',
        detectorSize: '20x20 cm (both planes)',
        rotation: 'Biplane configuration'
      },
      year: '2020',
      condition: 'Excellent - Premium Grade',
      availability: 'In Stock',
      image: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&h=600&fit=crop'
    }
  ],
  petct: [
    {
      id: 'pet-1',
      name: 'Siemens Biograph Emotion CT',
      manufacturer: 'Siemens Healthineers',
      category: 'PET CT',
      specifications: {
        slices: '64-slice CT',
        crystalType: 'LSO',
        axialFOV: '21.6 cm'
      },
      year: '2019',
      condition: 'Excellent - Premium Grade',
      availability: 'Available',
      image: 'https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800&h=600&fit=crop'
    },
    {
      id: 'pet-2',
      name: 'Siemens Biograph Emotion CT',
      manufacturer: 'Siemens Healthineers',
      category: 'PET CT',
      specifications: {
        slices: '16-slice CT',
        crystalType: 'LSO',
        axialFOV: '16.2 cm'
      },
      year: '2018',
      condition: 'Very Good - Complete Service',
      availability: 'Available',
      image: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&h=600&fit=crop'
    },
    {
      id: 'pet-3',
      name: 'Siemens Biograph Emotion Ct',
      manufacturer: 'Siemens Healthineers',
      category: 'PET CT',
      specifications: {
        slices: '6-Slice CT',
        crystalType: 'LSO',
        axialFOV: '14.5 cm'
      },
      year: '2017',
      condition: 'Good - Tested & Certified',
      availability: 'In Stock',
      image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&h=600&fit=crop'
    }
  ]
};

// Mock brochures data
export const mockBrochures = [
  {
    id: 'brochure-1',
    title: 'CT Scanners Catalog',
    category: 'CT Scanner',
    description: 'Complete catalog of available CT scanner models with specifications',
    fileSize: '2.5 MB',
    pages: 12,
    uploadDate: '2025-01-15'
  },
  {
    id: 'brochure-2',
    title: 'MRI Systems Brochure',
    category: 'MRI System',
    description: 'Detailed information about our MRI systems and capabilities',
    fileSize: '3.2 MB',
    pages: 16,
    uploadDate: '2025-01-15'
  },
  {
    id: 'brochure-3',
    title: 'Cath Lab Solutions',
    category: 'Cath Lab',
    description: 'Comprehensive guide to catheterization laboratory equipment',
    fileSize: '1.8 MB',
    pages: 8,
    uploadDate: '2025-01-15'
  },
  {
    id: 'brochure-4',
    title: 'PET CT Systems Guide',
    category: 'PET CT',
    description: 'Technical specifications and features of PET CT systems',
    fileSize: '2.1 MB',
    pages: 10,
    uploadDate: '2025-01-15'
  }
];

// Company contact information
export const contactInfo = {
  phone: '+91-7903127912',
  email: 'info@upglobal.in',
  whatsapp: '+91-7903127912',
  website: 'www.upglobal.in',
  address: {
    line1: '79A ROAD NO-06 SANJAY GANDHI NAGAR',
    line2: 'HANUMAN NAGAR',
    city: 'PATNA',
    state: 'BIHAR',
    pincode: '800026',
    country: 'INDIA'
  },
  businessHours: {
    weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
    saturday: 'Saturday: 9:00 AM - 2:00 PM',
    emergency: '24/7 Emergency Support Available'
  }
};

export const mockServices = [
  {
    id: 1,
    title: "CT Scanners",
    description: "High-quality refurbished CT scanners from leading manufacturers. Fully tested and certified for reliable diagnostic imaging.",
    icon: "scan"
  },
  {
    id: 2,
    title: "MRI Systems",
    description: "Premium refurbished MRI systems offering exceptional image quality and patient comfort for comprehensive diagnostics.",
    icon: "brain"
  },
  {
    id: 3,
    title: "Cath Labs",
    description: "State-of-the-art catheterization laboratory equipment for cardiovascular procedures with complete service support.",
    icon: "heart-pulse"
  },
  {
    id: 4,
    title: "PET CT Systems",
    description: "Advanced PET CT imaging systems for nuclear medicine and oncology applications with guaranteed performance.",
    icon: "activity"
  }
];

export const mockFeatures = [
  {
    id: 1,
    title: "Certified Quality",
    description: "All equipment undergoes rigorous testing and certification to meet industry standards.",
    icon: "badge-check"
  },
  {
    id: 2,
    title: "Pan India Service",
    description: "Comprehensive coverage across India with dedicated service teams in major cities.",
    icon: "map-pin"
  },
  {
    id: 3,
    title: "Expert Support",
    description: "24/7 technical support from experienced engineers and service professionals.",
    icon: "headset"
  },
  {
    id: 4,
    title: "Cost Effective",
    description: "Premium refurbished equipment at competitive prices without compromising quality.",
    icon: "trending-down"
  },
  {
    id: 5,
    title: "Warranty Assured",
    description: "Comprehensive warranty coverage on all equipment for your peace of mind.",
    icon: "shield-check"
  },
  {
    id: 6,
    title: "Installation Support",
    description: "Complete installation, training, and commissioning services included.",
    icon: "wrench"
  }
];

export const mockStats = [
  { label: "Years of Experience", value: "20+" },
  { label: "Equipment Installed", value: "65+" },
  { label: "Cities Covered", value: "28+" },
  { label: "Happy Clients", value: "50+" }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Dr. Rajesh Kumar",
    role: "Chief Radiologist, Apollo Hospitals",
    content: "Excellent service and quality equipment. The refurbished MRI system has been performing flawlessly for over 2 years.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Director, City Care Diagnostics",
    content: "Professional team with exceptional after-sales support. Highly recommend Upline Global Solutions for medical equipment needs.",
    rating: 5
  },
  {
    id: 3,
    name: "Dr. Mohammed Ansari",
    role: "Cardiologist, Fortis Healthcare",
    content: "The Cath Lab installation was seamless. Great value for money and reliable performance.",
    rating: 5
  }
];

export const handleContactSubmit = (formData) => {
  console.log('Contact form submitted:', formData);
  const contacts = JSON.parse(localStorage.getItem('contacts') || '[]');
  const newContact = {
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString()
  };
  contacts.push(newContact);
  localStorage.setItem('contacts', JSON.stringify(contacts));
  return { success: true, message: 'Thank you! We will contact you soon.' };
};

export const handleQuoteRequest = (formData) => {
  console.log('Quote request submitted:', formData);
  const quotes = JSON.parse(localStorage.getItem('quotes') || '[]');
  const newQuote = {
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString()
  };
  quotes.push(newQuote);
  localStorage.setItem('quotes', JSON.stringify(quotes));
  return { success: true, message: 'Quote request received! We will get back to you shortly.' };
};

export const handleBrochureDownload = (brochureId) => {
  console.log('Brochure download requested:', brochureId);
  // In production, this would trigger actual file download
  const downloads = JSON.parse(localStorage.getItem('brochureDownloads') || '[]');
  downloads.push({
    brochureId,
    timestamp: new Date().toISOString()
  });
  localStorage.setItem('brochureDownloads', JSON.stringify(downloads));
  return { success: true, message: 'Brochure download initiated' };
};